<template>
<div class="chapter">
<div class="inner_page">
<h1 class="section">TABLE OF CONTENTS</h1>
<p class="crt"><span href="#/text/tp" title="Link target outside of Sample">Title Page</span></p>
<p class="crt"><span href="#/text/cop" title="Link target outside of Sample">Copyright</span></p>
<p class="crt"><a href="#/text/map">Map of the Free Kingdoms</a></p>
<p class="crt"><a href="#/text/ded">Dedication</a></p>
<p class="crt1" id="c_fword"><a href="#/text/fword">Author’s Foreword</a></p>
<p class="crt1" id="c_c01"><a href="#/text/c01">Chapter 2</a></p>
<p class="crt" id="c_c02"><a href="#/text/c02">Chapter 6</a></p>
<p class="crt" id="c_c03"><span href="#/text/c03" title="Link target outside of Sample">Chapter π</span></p>
<p class="crt" id="c_c04"><span href="#/text/c04" title="Link target outside of Sample">Chapter 4 ½</span></p>
<p class="crt" id="c_c05"><span href="#/text/c05" title="Link target outside of Sample">Chapter 42</span></p>
<p class="crt" id="c_c06"><span href="#/text/c06" title="Link target outside of Sample">Chapter 144</span></p>
<p class="crt" id="c_c07"><span href="#/text/c07" title="Link target outside of Sample">Act V, Scene iii</span></p>
<p class="crt" id="c_c08"><span href="#/text/c08" title="Link target outside of Sample">Chapter A+</span></p>
<p class="crt" id="c_c09"><span href="#/text/c09" title="Link target outside of Sample">Chapter No!</span></p>
<p class="crt" id="c_c10"><span href="#/text/c10" title="Link target outside of Sample">Chapter 1010</span></p>
<p class="crt" id="c_c11"><span href="#/text/c11" title="Link target outside of Sample">Chapter 24601</span></p>
<p class="crt" id="c_c12"><span href="#/text/c12" title="Link target outside of Sample">Chapter 070706</span></p>
<p class="crt" id="c_c13"><span href="#/text/c13" title="Link target outside of Sample">Chapter 6.022140857 × 10<span class="super">23</span></span></p>
<p class="crt" id="c_c14"><span href="#/text/c14" title="Link target outside of Sample">Chapter Four Teens and a Pickle</span></p>
<p class="crt" id="c_c15"><span href="#/text/c15" title="Link target outside of Sample">Chapter 8675309</span></p>
<p class="crt" id="c_c16"><span href="#/text/c16" title="Link target outside of Sample">Chapter 16</span></p>
<p class="crt" id="c_c17"><span href="#/text/c17" title="Link target outside of Sample">Chapter NCC-1701</span></p>
<p class="crt" id="c_c18"><span href="#/text/c18" title="Link target outside of Sample">Chapter 4815162342</span></p>
<p class="crt" id="c_c19"><span href="#/text/c19" title="Link target outside of Sample">Chapter ???</span></p>
<p class="crt" id="c_c20"><span href="#/text/c20" title="Link target outside of Sample">Chapter ∞</span></p>
<p class="crt" id="c_c21"><span href="#/text/c21" title="Link target outside of Sample">Chapter ∞+1</span></p>
<p class="crt1" id="c_aword"><span href="#/text/aword" title="Link target outside of Sample">Author’s Afterword</span></p>
<p class="crt1" id="c_ata"><span href="#/text/ata" title="Link target outside of Sample">About the Author</span></p>
<p class="crt" id="c_ati"><span href="#/text/ati" title="Link target outside of Sample">About the Illustrator</span></p>
<p class="crt" id="c_ack"><span href="#/text/ack" title="Link target outside of Sample">Acknowledgements</span></p>
<p class="crt"><span href="#/text/ad" title="Link target outside of Sample">The Alcatraz Series</span></p>
<p class="crt"><span href="#/text/alsoby" title="Link target outside of Sample">Also by Brandon Sanderson</span></p>
<p class="crt"><span href="#/text/ty" title="Link target outside of Sample">Thank You from JABberwocky!</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?8dbde716